import React, { Component } from 'react'
import './preferenceModal.scss'
import { ModalBody, Modal, Row, Col } from "react-bootstrap";
import Select from 'react-select';
import { Button } from '../common';
import { shoppingMethod } from '../../utility/enums';
import { get } from './../../utility/apiClient';
import { UpdateCosmosDB, AddRecoveryCartItemToCart, getInitialDataCollection, updateOutlet } from './../../utility/commonFunctions';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { resetPreferenceModal } from '../../redux/actions/preferenceModalActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { addPreference } from '../../redux/actions/preferenceActions';
import { addPromotionItems } from '../../redux/actions/promotionItemsActions';
import { updateIsTemporaryCart, updateAddress, updateAddressDetails } from '../../redux/actions/userDetailsActions';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { addLatLongForLoyalty } from '../../redux/actions/V2_0/latLongForLoyalty';


/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        preferenceModal: state.preferenceModal,
        userData: state.userDetails,
        shoppingPreference: state.shoppingPreference,
        jkoaPurchase: state.jkoaPurchase,
        //itemCart: state.itemCart,
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    resetPreferenceModal,
    showLoadingScreen,
    hideLoadingScreen,
    addPreference,
    addPromotionItems,
    updateIsTemporaryCart,
    showMessageBox,
    updateAddress,
    updateAddressDetails,
    addLatLongForLoyalty
};

class PreferenceModal extends Component {
    constructor(props) {
        super();
        this.state = {
            activeTab: shoppingMethod.delivery,
            cityID: null,
            city: '',
            suburbID: null,
            suburb: '',
            outletID: null,
            selectedOutlet: null,
            searchSuburbID: null,
            errorMessage: "",
            cityList: [],
            suburbList: [],
            outletList: [],
            searchSuburbList: [],
            originalOutletList: [],
            filteredSuburbList: [],
            isSuburbBoxDisabled: true,

            suburbKey: 0,
            searchSuburbKey: 0,
            cityKey: 0,
            outletKey: 0,

            selectedSuburb: null,
            selectedCity: null,
            isVisible: false,

            isDisabledShopNowBtn: false,
            isQuotaFullMessage: false,

            showModal: false,

            //shipping details
            listShippingDetails: [],
            shippingDetailsList: [],
            shippingDetailsID: 0,
            shippingDetailsIDKey: 0,
            selectedShippingDetails: null,
        }
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleSuburbChange = this.handleSuburbChange.bind(this);
        this.handleOutletChange = this.handleOutletChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleShippingAddressChange = this.handleShippingAddressChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            activeTab: this.props.shoppingPreference.shoppingMethod.toLowerCase() === "delivery" ? shoppingMethod.delivery : shoppingMethod.pickup
        })
        // this.getComboData();
        this.getShippingAddress()
    };

    componentDidUpdate() {
        if (this.props.preferenceModal.show && !this.state.showModal) {
            this.setState({
                showModal: true
            }, () => {
                this.getComboData();
            })

        } else if (!this.props.preferenceModal.show && this.state.showModal) {
            this.setState({
                showModal: false,
            })
        }
    }

    redirectToGeoLocation(shippingDetail = null) {
        this.setState({
            isUserHasGeoLocation: false
        })
        const path = window.location.href.split('//');
        const baseUrl = path[1].split('/');
        let url = `http://${baseUrl[0]}/geoLocation?ID=${shippingDetail == null ? this.state.selectedShippingDetails[0].shippingDetailsID : shippingDetail[0].shippingDetailsID}&Path=cart`;
        window.location.href = url;
    }

    getComboData() {
        this.props.showLoadingScreen();
        get("/Web/GetDeliveryPreferences")
            .then(response => {
                if (response.data.statusCode == 200) {
                    let result = response.data.result;
                    let cityList = result.deliveryCityList.map(i => {
                        return {
                            value: i.cityId,
                            label: i.name
                        };
                    });
                    let suburbList = result.deliverySuburbsList;
                    let outletList = result.outletDetails.map(i => {
                        return {
                            value: i.outletCode,
                            label: i.outletDescription,
                            availablePickUpDates: i.availablePickUpDates
                        };
                    });
                    let searchSuburbList = result.deliverySuburbsList.map(i => {
                        return {
                            value: i.cityId,
                            label: i.name
                        };
                    });
                    this.setState({
                        cityList: cityList,
                        suburbList: suburbList,
                        searchSuburbList: searchSuburbList,
                        outletList: outletList,
                        originalOutletList: result.outletDetails,
                        searchSuburbID: this.state.activeTab === shoppingMethod.delivery ? this.props.shoppingPreference.suburbID : null,
                        outletID: this.state.activeTab === shoppingMethod.pickup ? this.props.shoppingPreference.outletCode : null,
                    }, () => {
                        if (this.state.searchSuburbID !== null) {
                            this.handleSearchSuburb()
                        }
                        if (this.state.outletID !== null) {
                            let outlet = this.state.outletList.find(a => a.value === this.state.outletID);
                            this.setState({
                                selectedOutlet: outlet ? outlet : null,
                                outletID: outlet ? this.state.outletID : null
                            }, () => {
                                this.handleQuotaFullMessage()
                            })
                        }
                    })
                    this.setState({ isVisible: true });
                } else {
                    this.setState({ isVisible: true });
                }
                this.props.hideLoadingScreen();
            })
    };

    getSuburbs() {
        if (this.state.cityID) {
            let filteredList = this.state.suburbList.filter(x => x.deliveryCityId === this.state.cityID);
            filteredList = filteredList.map(i => {
                return {
                    value: i.cityId,
                    label: i.name,
                    availableDeliveryDates: i.availableDeliveryDates
                };
            });
            this.setState({
                filteredSuburbList: filteredList,
                isSuburbBoxDisabled: false
            }, () => { this.handleQuotaFullMessage() })
        } else {
            this.setState({
                filteredSuburbList: [],
                isSuburbBoxDisabled: true
            }, () => {
                this.handleQuotaFullMessage()
            });
        }
    };

    handleOutletChange(e) {
        this.setState({
            outletID: e ? e.value : null,
            selectedOutlet: e,
            isDisabledShopNowBtn: e ? true : false,
            isQuotaFullMessage: e ? true : false
        }, () => {
            if (this.state.outletID) {
                this.validatePickup();
                this.handleQuotaFullMessage()
            }
        })
    };

    handleCityChange(e) {
        this.setState({
            cityID: e ? e.value : null,
            selectedCity: e ? e : null,
            suburbID: null,
            selectedSuburb: null,
            suburbKey: this.state.suburbKey + 1
        }, () => {
            this.getSuburbs();
            // this.handleQuotaFullMessage();
        })
    };

    handleSuburbChange(e) {
        this.setState({
            suburbID: e ? e.value : null,
            selectedSuburb: e ? e : null,
            isDisabledShopNowBtn: e ? true : false,
            isQuotaFullMessage: e ? true : false
        }, () => {
            if (this.state.suburbID) {
                this.validateDelivery();
                this.handleQuotaFullMessage();
            }
        })
    };

    handleSearchSuburbChange(e) {
        if (e) {
            let suburb = this.state.suburbList.find(x => x.cityId === e.value);
            this.setState({
                searchSuburbID: suburb.cityId
            }, () => {
                this.handleSearchSuburb();
            })
        }
    };

    handleSearchSuburb() {
        let suburb = this.state.suburbList.find(x => x.cityId === this.state.searchSuburbID);
        if (suburb) {
            let selectedCity = this.state.cityList.find(x => x.value === suburb.deliveryCityId);
            if (selectedCity) {
                let selectedSuburb = {
                    value: suburb.cityId,
                    label: suburb.name
                }
                this.setState({
                    cityID: suburb.deliveryCityId,
                    suburbID: suburb.cityId,
                    selectedSuburb: selectedSuburb,
                    selectedCity: selectedCity
                }, () => {
                    this.getSuburbs();
                    this.validateDelivery();
                    // this.handleQuotaFullMessage();
                })
            }
        }

        if (this.state.outletID !== null) {
            let outlet = this.state.outletList.find(a => a.value === this.state.outletID);
            this.setState({ selectedOutlet: outlet })
        }

    }

    validateDelivery() {

        let shippingDetail = this.state.listShippingDetails.filter(a => a.shippingDetailsID === this.state.selectedShippingDetails.value);
        if (shippingDetail[0].suburbID) {
            this.hideErrorMessage();
            return true;
        } else {
            let message = "A City and Suburb is required";
            if (!shippingDetail[0].suburbID) {
                message = "A Suburb is required";
            }

            if (!shippingDetail[0].city) {
                message = "A City is required";
            }
            this.setState({
                errorMessage: message
            })
        }
        return false;
    };

    validatePickup() {
        if (this.state.outletID) {
            this.hideErrorMessage();
            return true;
        } else {
            this.setState({
                errorMessage: "An Outlet is required"
            })
        }
        return false;
    };

    handleQuotaFullMessage() {
        if (this.state.activeTab == shoppingMethod.delivery) {
            if (this.state.selectedSuburb != null) {
                let suburb = this.state.suburbList.find(x => x.cityId === this.state.selectedSuburb.value);
                let suburbMaxOrdersReached = suburb.availableDeliveryDates.availableDateRange.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
                if (suburbMaxOrdersReached && suburbMaxOrdersReached != undefined) {
                    if (suburb.branchCode === suburb.substituteOutletCode) {
                        this.setState({
                            isDisabledShopNowBtn: true,
                            isQuotaFullMessage: true
                        })
                    }
                    else {
                        this.setState({
                            isDisabledShopNowBtn: false,
                            isQuotaFullMessage: false
                        })
                    }
                }
                else {
                    this.setState({
                        isDisabledShopNowBtn: false,
                        isQuotaFullMessage: false
                    })
                }
            }
            else {
                if (this.state.filteredSuburbList.length > 0) {
                    let _filteredSuburb = [];
                    this.state.filteredSuburbList.map(i => {
                        i.availableDeliveryDates.availableDateRange.map(date => {
                            _filteredSuburb.push(date)
                        })
                    })
                    let isMaxOrderReachedCity = _filteredSuburb.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
                    if (!isMaxOrderReachedCity) {
                        this.setState({
                            isDisabledShopNowBtn: false,
                            isQuotaFullMessage: false
                        })
                    } else {
                        this.setState({
                            isDisabledShopNowBtn: true,
                            isQuotaFullMessage: true
                        })
                    }
                }
            }
        } else {
            if (this.state.outletID != null) {
                let _outlet = this.state.originalOutletList.find(x => x.outletCode === this.state.outletID);
                let maxOrdersReached = _outlet.availablePickUpDates.availableDateRange.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
                if (maxOrdersReached && maxOrdersReached != undefined) {
                    this.setState({
                        isDisabledShopNowBtn: true,
                        isQuotaFullMessage: true
                    })
                }
                else {
                    this.setState({
                        isDisabledShopNowBtn: false,
                        isQuotaFullMessage: false
                    })
                }
            } else {
                this.setState({
                    isDisabledShopNowBtn: false,
                    isQuotaFullMessage: false
                })
            }
        }
    };

    hideErrorMessage() {
        this.setState({
            errorMessage: ""
        })
    };

    switchTabs(value) {
        this.setState({
            activeTab: value,
            errorMessage: "",
            searchSuburbKey: this.state.searchSuburbKey + 1,

        }, () => {
            this.handleQuotaFullMessage()
        });
    }

    handleSubmit() {
        if (this.props.jkoaPurchase && (this.state.activeTab === shoppingMethod.pickup)) {
            this.setState({
                errorMessage: "You can't change the delivery method to Pick up when you're going to purchase the Electronic items"
            });
            return;
        }
        if (this.state.activeTab === shoppingMethod.delivery) {
            if (this.validateDelivery()) {
                this.props.showLoadingScreen();
                let shippingDetail = this.state.listShippingDetails.filter(a => a.shippingDetailsID === this.state.selectedShippingDetails.value);
                let outlet = this.state.suburbList.find(x => x.cityId === shippingDetail[0].suburbID);
                if(outlet){
                    let data = {
                        outletCode: outlet.maxOrdersReached ? outlet.substituteOutletCode : outlet.branchCode,
                        outletName: outlet.maxOrdersReached ? outlet.substituteOutletDescription : outlet.branchName,
                        shoppingMethod: "Delivery",
                        mainOutletCode: outlet.branchCode,
                        mainOutletDescription: outlet.branchName,
                        suburbID: shippingDetail[0].suburbID,
                        maxOrdersReached: outlet.maxOrdersReached,
                        availableDeliveryDates: outlet.availableDeliveryDates
                    }
                    this.props.addPreference(data).then(() => {
                        UpdateCosmosDB(false, true);
                        let addressBody = {
                            addressLine1: this.state.AddressLine1,
                            addressLine2: this.state.AddressLine2,
                            city: this.state.city,
                            shippingDetailsID: shippingDetail[0].shippingDetailsID,//this.state.shippingDetailsID-[Bug][Task]-30583: Delivery charge 0 issue
                            selectedOutlet: outlet.maxOrdersReached ? outlet.substituteOutletCode : outlet.branchCode
                        }
                        this.props.updateAddress(addressBody);
                        getInitialDataCollection(() => {
                            updateOutlet(() => {
                                this.props.hideLoadingScreen();
                                this.props.resetPreferenceModal().then(() => {
                                    window.location.href = "/cart";
                                })
                            });
                        });
                    })
                } else {
                    let messageBox = {
                        show: true,
                        title: "Error",
                        className: "error",
                        content: 'Delivery city you have selected previously is temporarily blocked. Please enter a new address to proceed further.',
                        isConfirmation: false,
                        callBackFunction: () => {}
                    }
                    this.props.showMessageBox(messageBox);
                    this.props.hideLoadingScreen();
                }

            }
        } else if (this.state.activeTab === shoppingMethod.pickup) {
            if (this.validatePickup()) {
                this.props.showLoadingScreen();
                let outlet = this.state.originalOutletList.find(x => x.outletCode === this.state.outletID);
                let data = {
                    outletCode: outlet.outletCode,
                    outletName: outlet.outletDescription,
                    shoppingMethod: "Pickup",
                    mainOutletCode: outlet.outletCode,
                    mainOutletDescription: outlet.outletDescription,
                    suburbID: 0,
                    availableDeliveryDates: outlet.availablePickUpDates,
                    maxOrdersReached: outlet.maxOrdersReached,
                }
                this.props.addPreference(data).then(() => {
                    UpdateCosmosDB(false, true);
                    getInitialDataCollection(() => {
                        updateOutlet(() => {
                            this.props.hideLoadingScreen();
                            this.props.resetPreferenceModal().then(() => {
                                window.location.href = "/cart";
                            })
                        });
                    });
                })
            }
        } else {
            this.setState({
                errorMessage: "Please select the shipping method"
            })
        }
    };

    // updateOutlet(callback) {
    //     this.props.showLoadingScreen();
    //     get(`/Web/GetTemporarySavedCart?outletCode=${this.props.shoppingPreference.outletCode}`).then(response => {
    //         if (response.data.statusCode === 200) {
    //             if (response.data.result.itemDetailsList !== null) {
    //                 this.props.addPromotionItems(response.data.result.promotionItemDetailsList).then(() => {
    //                     AddRecoveryCartItemToCart(response.data.result.itemDetailsList, false, () => {
    //                         this.props.updateIsTemporaryCart(false);
    //                         this.props.hideLoadingScreen();
    //                         callback();
    //                     });
    //                     const UpdatedCount = response.data.result.itemDetailsList.filter(item => (item.isUpdateQuantity === true));
    //                     if (UpdatedCount.length > 0) {
    //                         let messageBox = {
    //                             show: true,
    //                             title: "Oops!",
    //                             className: "warning",
    //                             content: response.data.errorList[0].statusMessage,
    //                             isConfirmation: false,
    //                             callBackFunction: null
    //                         }
    //                         this.props.hideLoadingScreen();
    //                         this.props.showMessageBox(messageBox);
    //                     }
    //                 })
    //             }
    //             else {
    //                 this.props.hideLoadingScreen();
    //                 callback();
    //             }
    //         } else {
    //             let messageBox = {
    //                 show: true,
    //                 title: "Oops!",
    //                 className: "error",
    //                 content: response.data.errorList[0].statusMessage,
    //                 isConfirmation: false,
    //                 callBackFunction: null
    //             }
    //             this.props.hideLoadingScreen();
    //             this.props.showMessageBox(messageBox);
    //         }
    //     })
    // };

    /*--Handle Shipping Address Change--*/
    handleShippingAddressChange(e) {
        this.setState({
            shippingDetailsID: e ? e.value : null,
            selectedShippingDetails: e ? e : null,
        }, () => { this.setShippingAddress(); })
    };


    getShippingAddress() {
        if (this.state.activeTab === shoppingMethod.delivery) {
            this.props.showLoadingScreen();
            get('/MyAccount/LoadShippingDetails')//do here
                .then(response => {
                    if (response.status == 200) {
                        if (response.data.statusCode == 200) {

                            let completeShippingAddress = response.data.result.listShippingDetails.filter(elm => elm.addressLine1 !== "" && elm.addressLine2 !== "" && elm.city !== "" && elm.latitude > 0 && elm.suburbID > 0 && elm.longitude > 0);
                            let shippingDetailsList = completeShippingAddress.map(i => {
                                return {
                                    value: i.shippingDetailsID,
                                    label: i.addressTypeName + " | " + i.addressLine1 + ", " + i.addressLine2 + ", " + i.city
                                };
                            });
                            let defaultShippingDetails = null;
                            let tempdefaultShipAddress = completeShippingAddress.find(x => x.shippingDetailsID == this.props.userData.shippingDetailsID);
                            if (tempdefaultShipAddress) {
                                defaultShippingDetails = {
                                    value: tempdefaultShipAddress.shippingDetailsID,
                                    label: tempdefaultShipAddress.addressTypeName + " | " + tempdefaultShipAddress.addressLine1 + ", " + tempdefaultShipAddress.addressLine2 + ", " + tempdefaultShipAddress.city
                                }
                            } else {
                                tempdefaultShipAddress = completeShippingAddress[0]
                                if (tempdefaultShipAddress) {
                                    defaultShippingDetails = {
                                        value: tempdefaultShipAddress.shippingDetailsID,
                                        label: tempdefaultShipAddress.addressTypeName + " | " + tempdefaultShipAddress.addressLine1 + ", " + tempdefaultShipAddress.addressLine2 + ", " + tempdefaultShipAddress.city
                                    }
                                }
                            }

                            let isCustomAddress = completeShippingAddress.length > 0 ? false : true;

                            this.setState({
                                listShippingDetails: response.data.result.listShippingDetails,
                                shippingDetailsList,
                                shippingDetailsID: defaultShippingDetails ? defaultShippingDetails.shippingDetailsID : 0,
                                selectedShippingDetails: defaultShippingDetails ? defaultShippingDetails : [],
                                shippingDetailsIDKey: this.state.shippingDetailsIDKey + 1,
                                showHeavyLoadMessage: response.data.result.showHeavyLoadMessage,
                                isCustomAddress
                            }, () => {
                                this.props.hideLoadingScreen();
                                this.setShippingAddress();
                            })
                        } else {
                            this.props.hideLoadingScreen();
                            let messageBox = {
                                show: true,
                                title: "Oops!",
                                className: "error",
                                content: response.data.errorList[0].statusMessage,
                                isConfirmation: false
                            }
                            this.props.showMessageBox(messageBox);
                        }
                    } else {
                        this.props.hideLoadingScreen();
                    }
                })
            //Get delivery dates
            this.props.showLoadingScreen();
        }
    }

    setShippingAddress() {
        let shippingDetail = this.state.listShippingDetails.filter(a => a.shippingDetailsID === this.state.selectedShippingDetails.value);
        let outlet = this.state.suburbList.find(x => x.cityId === shippingDetail[0].suburbID);

        if (shippingDetail) {
            if (shippingDetail.length > 0 ) {
                if (shippingDetail[0].suburbID > 0 && shippingDetail[0].latitude > 0 && outlet) {
                    this.setState({
                        AddressLine1: shippingDetail[0].addressLine1,
                        AddressLine2: shippingDetail[0].addressLine2,
                        City: shippingDetail[0].city,
                        isAddressLine1Valid: true,
                        isAddressLine2Valid: true,
                        isCityValid: true,
                        isUserHasGeoLocation: true,
                        lat: shippingDetail[0].latitude,
                        lon: shippingDetail[0].longitude
                    })
                    let GeoLocationForLoyalty = {
                        geolocationLatitudeforLoyalty: shippingDetail[0].latitude,
                        geolocationLongitudeforLoyalty: shippingDetail[0].longitude
                    }
                    this.props.addLatLongForLoyalty(GeoLocationForLoyalty);
                    let addressBody = {
                        addressLine1: shippingDetail[0].addressLine1,
                        addressLine2: shippingDetail[0].addressLine2,
                        city: shippingDetail[0].city,
                        shippingDetailsID: this.state.selectedShippingDetails.value
                    }
                    this.props.updateAddressDetails(addressBody);
                } else {

                    this.setState({
                        AddressLine1: '',
                        AddressLine2: '',
                        City: '',
                        isAddressLine1Valid: false,
                        isAddressLine2Valid: false,
                        isCityValid: false
                    })
                    // this.redirectToGeoLocation(shippingDetail);
                }

            } else {
                this.setState({
                    AddressLine1: '',
                    AddressLine2: '',
                    City: '',
                    isAddressLine1Valid: false,
                    isAddressLine2Valid: false,
                    isCityValid: false
                })
            }
        } else {
            this.setState({
                AddressLine1: '',
                AddressLine2: '',
                City: '',
                isAddressLine1Valid: false,
                isAddressLine2Valid: false,
                isCityValid: false
            })
        }
    }

    render() {
        return (
            <React.Fragment>
                <Modal size="md" centered className="popup-box" show={this.props.preferenceModal.show === undefined ? false : this.props.preferenceModal.show}>
                    <ModalBody>
                        <div className="product-magnifier-content-holder">
                            <Row>
                                <Col>
                                    <div className='product-magnifier-close-btn mb-3' onClick={() => { this.props.resetPreferenceModal(); }}>X</div>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <Col md="12 form-group">
                                    <Row className={"m-0 d-flex justify-content-center"}>
                                        <Button onClick={this.switchTabs.bind(this, shoppingMethod.delivery)} primary={this.state.activeTab === shoppingMethod.delivery} lightGray={this.state.activeTab === shoppingMethod.pickup} className=" mr-2 no-right-radius">Delivery</Button>

                                        <Button onClick={this.switchTabs.bind(this, shoppingMethod.pickup)} primary={this.state.activeTab === shoppingMethod.pickup} lightGray={this.state.activeTab === shoppingMethod.delivery} className=" no-left-radius ">Pickup</Button>
                                    </Row>
                                </Col>
                            </Row>
                            {this.state.activeTab === shoppingMethod.delivery ?
                                <React.Fragment>
                                    {/* <Row className="text-center">
                                        <Col md="12 form-group">
                                            <Select options={this.state.searchSuburbList}
                                                key={this.state.searchSuburbKey}
                                                placeholder="Search a Suburb"
                                                isClearable={true}
                                                onChange={this.handleSearchSuburbChange.bind(this)}
                                                id="searchSuburbBox"
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: '0px 25px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#B3B3B3',
                                                        primary: '#64bf47',
                                                        neutral0: '#EFEFEF'
                                                    },
                                                })}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="text-center">
                                        <Col md="12 form-group">
                                            <Select options={this.state.cityList}
                                                key={this.state.cityKey}
                                                value={this.state.selectedCity}
                                                placeholder="Select a City"
                                                isClearable={true}
                                                onChange={this.handleCityChange}
                                                id="cityBox"
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: '0px 25px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#B3B3B3',
                                                        primary: '#64bf47',
                                                        neutral0: '#EFEFEF'
                                                    },
                                                })}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="text-center">
                                        <Col md="12 form-group">
                                            <Select options={this.state.filteredSuburbList}
                                                key={this.state.suburbKey}
                                                value={this.state.selectedSuburb}
                                                isDisabled={this.state.isSuburbBoxDisabled}
                                                placeholder="Select a Suburb"
                                                isClearable={true}
                                                onChange={this.handleSuburbChange}
                                                id="suburbBox"
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: '0px 25px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#B3B3B3',
                                                        primary: '#64bf47',
                                                        neutral0: '#EFEFEF'
                                                    },
                                                })}
                                            />
                                        </Col>
                                    </Row> */}
                                    <Select options={this.state.shippingDetailsList}
                                        key={this.state.shippingDetailsIDKey}
                                        value={this.state.selectedShippingDetails}
                                        placeholder="Select a Shipping Address"
                                        isClearable={false}
                                        onChange={this.handleShippingAddressChange}
                                        id="ShippingAddress"
                                        isDisabled={this.state.isCustomAddress}
                                        theme={theme => ({
                                            ...theme,
                                            borderRadius: '0px 25px',
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#B3B3B3',
                                                primary: '#64bf47',
                                                neutral0: 'white'
                                            },
                                        })}
                                    />
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <Row className="text-center">
                                        <Col md="12 form-group">
                                            <Select options={this.state.outletList}
                                                key={this.state.outletKey}
                                                placeholder="Select a Outlet"
                                                isClearable={true}
                                                value={this.state.selectedOutlet}
                                                onChange={this.handleOutletChange}
                                                id="outletBox"
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: '0px 25px',
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#B3B3B3',
                                                        primary: '#64bf47',
                                                        neutral0: '#EFEFEF'
                                                    },
                                                })}
                                            />
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            }


                            <Row className="text-center">
                                <Col md="12 form-group">
                                    <span className={`form-text text-muted preference-modal-error-message col ${(this.state.isQuotaFullMessage == true) ? '' : 'd-none'}`}>{this.state.activeTab === shoppingMethod.delivery ? "Sorry, we have reached the maximum number of orders for the day. Please try a different delivery location" : "Sorry, we have reached the maximum number of orders for the day. Please try a different pickup store"}</span>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <Col md="12 form-group">
                                    <span className="form-text text-muted preference-modal-error-message col">{this.state.errorMessage}</span>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <Col md="12 form-group">
                                    <Button disabled={this.state.isDisabledShopNowBtn} primary onClick={this.handleSubmit}>Change</Button>
                                </Col>
                            </Row>
                        </div>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferenceModal);